import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const removeDocumentById = (id) => {
    //[##]PROBAR
    return axios.post(`/api/SkGAP/gapdocumentdeactivate/${id}`, { headers: authHeaderJson() } )
};

export {
    removeDocumentById
}